import { Image, Text, View } from '@react-pdf/renderer'
import Logo from '../../../assets/sideBarLogo.png'
import { styles } from '../styles'
import { APP_CONTACT } from '../../../utils/constants'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <View style={styles.footerContainer}>
      <View style={styles.logoSection}>
        <Image src={Logo} style={styles.logo} />
      </View>
      <View style={styles.companySection}>
        <Text style={styles.footerCompagnyText}>{t('brandName')}</Text>
        <Text style={styles.footerText}>{t('brandDomain')}</Text>
      </View>
      <View style={styles.contactSection}>
        <Text style={styles.footerInfo}>{t('forMoreInfoMsg')}</Text>
        <Text style={styles.footerInfo}>
          {t('contactUs')} <Text style={styles.boldText}>{APP_CONTACT}</Text>
        </Text>
      </View>
    </View>
  )
}

export default Footer
